import { NgModule } from '@angular/core';
import { SortPropertyPipe } from './sort-property-pipe';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [SortPropertyPipe],
  imports: [CommonModule],
  exports: [SortPropertyPipe],
})
export class SortPropertyPipeModule {}
